import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { SearchExpression, SortExpression, IQueryResult, CacheService, QueryService } from '@kpd/framework-ngx';
import { environment, apiUrl } from 'environments/environment';

export abstract class UserManagementQueryService extends QueryService {
  constructor(protected httpClient: HttpClient, protected cache?: CacheService, protected cachePrefix?: string) {
    super(httpClient, environment, apiUrl, cache, cachePrefix);
  }

  getEntities<T>(
    path: string,
    searchExpression?: SearchExpression,
    sortExpression?: SortExpression,
    skip?: number,
    take?: number,
  ): Observable<IQueryResult> {
    return super.getDTOs<T[]>(path, searchExpression, sortExpression, skip, take).pipe(
      map((items: T[]) => {
        return { result: items, totalCount: items.length } as IQueryResult;
      }),
    );
  }

  protected getDtoById(path: string, cachePrefix: string, clearCache: boolean, dtoMapper: any): Observable<any> {
    return super.getDtoById(path, cachePrefix, clearCache, dtoMapper, ['404', '401']);
  }

  createRoute(
    entitiesName: string,
    _pageNumber: number,
    _pageSize: number,
    _includeTotalCount: boolean,
    _searchExpression?: SearchExpression,
    _sortExpression?: SortExpression,
  ): string {
    return entitiesName;
  }
}
